/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import { mapState } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import { payTypeMapping } from '@/constant';
// import EditCount from './EditCount'
import ServiceAmountTable from './ServiceAmountTable/index';
export default {
  components: {
    ViewBox: ViewBox,
    Previewer: Previewer,
    // EditCount,
    ServiceAmountTable: ServiceAmountTable
  },
  directives: {
    // 指令
    TransferDom: TransferDom
  },
  props: {
    orderId: String,
    orderInfo: [Object, Array],
    reloadflag: {
      type: Boolean,
      default: false
    },
    moneyItemEditRoles: {
      type: Array
    },
    orderService: Object,
    isCollaboratorView: Number,
    is_view_settlement: [String, Number]
  },
  data: function data() {
    return {
      isMainPersonEditCount: false,
      isCollaboratorEditCount: false,
      extServiceItems: [],
      payTypeMapping: payTypeMapping,
      editShow: false,
      service: {},
      sparePartList: [],
      moneyItemList: [],
      pics: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var $$ = document.querySelectorAll.bind(document);
          var thumbnail = $$('.previewer-demo-img')[index];
          if (thumbnail) {
            var _thumbnail = $$('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        },
        shareEl: true,
        shareButtons: [{
          id: 'download',
          label: " " + i18n.tc("335") + " ",
          url: '{{raw_image_url}}',
          download: true
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    otherServiceCost: function otherServiceCost() {
      return this.extServiceItems.reduce(function (p, c) {
        return p + c.service_price * c.service_num;
      }, 0);
    },
    picsForPreviewer: function picsForPreviewer() {
      return this.pics.map(function (item) {
        return {
          src: item.img_url
        };
      });
    },
    // 编辑款项
    iseditCount: function iseditCount() {
      this.moneyItemEditRoles = this.moneyItemEditRoles || [];
      var moneyItemEditRoles = this.moneyItemEditRoles.concat([{
        fk_t_ep_role_id: 3
      }]);
      var rolelist = moneyItemEditRoles.map(function (item) {
        return item.fk_t_ep_role_id;
      }).includes(this.user.sysrole);
      var isCoopCanView = this.isCollaboratorView && this.orderInfo.coordination_user_id && this.orderInfo.coordination_user_id.split(',').map(Number).includes(this.user.id);
      var isOrderOver = this.orderInfo.state === 5 && this.orderInfo.is_create_settlement === 1;
      var is_receipt = this.orderInfo.is_receipt; // 是否开启工单回执
      var is_create_settlement = this.orderInfo.is_create_settlement; // 是否开启收款
      var is_create_receipt = this.orderInfo.is_create_receipt; // 是否填写回执
      var is_settlement = this.orderInfo.is_settlement; // 是否收款
      var is_order_charge = this.orderInfo.is_order_charge; // 是否开启服务款项
      var is_create_charge = this.orderInfo.is_create_charge; // 是否填写过服务款项
      var state5 = this.orderInfo.state === 5 && (is_receipt === 1 && is_create_receipt === 0 || is_receipt === 0 && is_create_settlement === 1 && is_settlement === 0 || is_receipt === 0 && is_create_settlement === 0 && is_order_charge === 1 && is_create_charge === 0);
      var isMain = this.user.id === this.orderInfo.fk_t_visit_user_id && this.isMainPersonEditCount;
      var isColl = isCoopCanView && this.isCollaboratorEditCount;
      return Boolean(this.orderInfo.is_order_charge === 1 &&
      // 是否开启服务款项
      !isOrderOver && (
      // 工单结算
      (isMain || isColl) && [3, 4].includes(this.orderInfo.state) || rolelist && ([1, 2, 3, 4].indexOf(this.orderInfo.state) !== -1 || state5)));
    }
  }),
  watch: {
    reloadflag: function reloadflag(val) {
      if (val) {
        this.reload();
      }
    },
    editShow: function editShow(val) {
      var _this = this;
      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.editShow = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
    }
  },
  methods: {
    reload: function reload() {
      this.editShow = false;
      this.load();
    },
    load: function load() {
      if (this.orderService) {
        var data = this.orderService;
        this.service = data.service;
        this.sparePartList = data.sparePartList;
        this.moneyItemList = data.moneyItemList;
        this.pics = data.pics ? data.pics : [];
        this.extServiceItems = data.extServiceItems || [];
      }
    },
    show: function show(index) {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs['previewer'].show(index);
      });
    }
  },
  created: function created() {
    this.load();
  }
};